<template>
	<div>
		<p class="font-medium text-gray-700" v-if="!noLabel">
			{{ __("Fulfilment Date") }}
		</p>
		<!-- date type -->
		<ui-validation-message
			:form="form"
			:field="f + 'date.type'"
			v-if="form.hasErrors"
		/>
		<div class="gap-x-6 gap-y-2 mt-1 flex-wrap sm:flex space-y-2 sm:space-y-0">
			<select
				class="pr-8"
				:class="[
					'text-gray-900 shadow-sm focus:ring-orange-500 focus:border-orange-500 block w-full border-gray-300 rounded-md',
				]"
				v-model="dateTypeChecker"
			>
				<option
					:key="f + 'AT_HARVEST-' + dateTypeChecker"
					:value="'AT_HARVEST'"
				>
					{{ __("At Harvest") }}
				</option>
				<option :key="f + 'MONTH-' + dateTypeChecker" :value="'MONTH'">
					{{ __("Month") }}
				</option>
				<option :key="f + 'MULTIPLE-' + dateTypeChecker" :value="'MULTIPLE'">
					{{ __("Consecutive Months without Storage Fee") }}
				</option>
				<option :key="f + 'BASIS-' + dateTypeChecker" :value="'BASIS'">
					{{ __("Consecutive Months with Storage Fee") }}
				</option>
			</select>
		</div>

		<div
			class="mt-1 flex gap-x-6 gap-y-2 flex-wrap align-baseline"
			v-if="dateTypeChecker == 'MONTH'"
		>
			<ui-month-input-group
				v-model="monthTo"
				:field="f + 'date.month_to'"
				label="Month"
				:form="form"
				:required="true"
				:key="f + 'MONTH_TO-' + dateTypeChecker"
			></ui-month-input-group>
		</div>

		<!-- :class="'grid-cols-' + gridCols" -->
		<div
			class="mt-1 flex gap-x-6 gap-y-2 items-center"
			v-else-if="['MULTIPLE', 'BASIS'].includes(dateTypeChecker)"
		>
			<ui-month-input-group
				class="min-w-48"
				v-model="monthFrom"
				:field="f + 'date.month_from'"
				label="Month From"
				:form="form"
				:required="true"
				:key="f + 'MONTH_FROM-' + dateTypeChecker"
			></ui-month-input-group>

			<ui-month-input-group
				class="min-w-48"
				v-model="monthTo"
				:field="f + 'date.month_to'"
				label="Month To"
				:form="form"
				:required="true"
				:key="f + 'MONTH_TO-' + dateTypeChecker"
			></ui-month-input-group>

			<ui-validation-message
				:form="form"
				:field="f + 'form.date.multiple_mode'"
				v-if="form.hasErrors"
			/>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
		gridCols: {
			type: String,
			default: "4",
		},
		noLabel: {
			type: Boolean,
			default: false,
		},
		idx: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			userType: this.$inertia.page.props.user?.type,
		};
	},
	computed: {
		f() {
			// prefix for the validation key
			return "offers." + this.idx + ".";
		},
		dateTypeChecker: {
			get() {
				return this.form.offers[this.idx].date.type;
			},
			set(newValue) {
				this.form.offers[this.idx].date.type = newValue;

				if (newValue == "AT_HARVEST") {
					this.form.offers[this.idx].date.month_from = null;
					this.form.offers[this.idx].date.month_to = null;
					this.form.offers[this.idx].date.multiple_mode = null;
				} else if (newValue == "MONTH") {
					this.form.offers[this.idx].date.month_from = null;
					this.form.offers[this.idx].date.multiple_mode = null;
				} else if (newValue == "BASIS") {
					this.form.offers[this.idx].date.multiple_mode = null;
				} else {
					this.form.offers[this.idx].date.multiple_mode = "BY_AGREEMENT";
				}
			},
		},
		monthFrom: {
			get() {
				return this.form.offers[this.idx].date.month_from;
			},
			set(newValue) {
				this.form.offers[this.idx].date.month_from = newValue;
			},
		},
		monthTo: {
			get() {
				return this.form.offers[this.idx].date.month_to;
			},
			set(newValue) {
				this.form.offers[this.idx].date.month_to = newValue;
			},
		},
	},
};
</script>
